import type { ReactNode } from "react";

import type { LocalAudioRecordingBlobRecord } from "@/domains/dexie-db/models/audio-recording";
import {
  AudioRecordingCard,
  AudioRecordingCardBody,
  AudioRecordingCardHeader,
} from "@/pages/audio-recordings/shared/audio-recording-card";
import { computeAudioRecordingBlobStats } from "@/pages/audio-recordings/shared";
import { CapturedBlobsSectionContent } from "./captured-blobs-section-content";

export type CapturedAudioBlobsCardProps = {
  blobs: LocalAudioRecordingBlobRecord[];
  emptyMessage?: string;
  title?: string;
  headerTitle?: string;
  headerActions?: ReactNode;
};

export const CapturedAudioBlobsCard = ({
  blobs,
  emptyMessage = "No blobs recorded yet. Start recording to capture audio.",
  title = "Captured Blobs",
  headerTitle = "Captured Audio",
  headerActions,
}: CapturedAudioBlobsCardProps) => {
  const stats = computeAudioRecordingBlobStats(blobs);

  return (
    <AudioRecordingCard>
      <AudioRecordingCardHeader title={headerTitle} actions={headerActions} />
      <AudioRecordingCardBody>
        <CapturedBlobsSectionContent
          blobs={blobs}
          stats={{
            blobCount: blobs.length,
            totalDurationLabel: stats.totalDurationLabel,
            totalSizeLabel: stats.totalSizeLabel,
            uploadedCount: stats.uploadedCount,
          }}
          emptyMessage={emptyMessage}
          title={title}
        />
      </AudioRecordingCardBody>
    </AudioRecordingCard>
  );
};
